import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;
const AUTH = 'Basic ' + btoa(`${process.env.REACT_APP_API_USER}:${process.env.REACT_APP_API_PASS}`);

export const useApi = () => {
  const [educations, setEducations] = useState([]);
  const [programming, setProgramming] = useState([]);
  const [user, setUser] = useState({});
  const [skills, setSkills] = useState([]);
  const [experience, setExperience] = useState([]);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchData();
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${API_URL}/users/`, {
        headers: { Authorization: AUTH }
      });
      if (!response.ok) throw new Error('Failed to fetch user data');
      const userData = await response.json();
      setUser(userData[0]);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const fetchData = async () => {
    try {
      const headers = { Authorization: AUTH };

      const educationData = await (await fetch(`${API_URL}/education/`, { headers })).json();
      setEducations(educationData);

      const programmingData = await (await fetch(`${API_URL}/programming/`, { headers })).json();
      setProgramming(programmingData);

      const skillsData = await (await fetch(`${API_URL}/skills/`, { headers })).json();
      setSkills(skillsData);

      const experienceData = await (await fetch(`${API_URL}/experience/`, { headers })).json();
      setExperience(experienceData);

      const projectsData = await (await fetch(`${API_URL}/projects/`, { headers })).json();
      projectsData.sort((a, b) => a.title.localeCompare(b.title));
      setProjects(projectsData);

      const categoryData = await (await fetch(`${API_URL}/categories/`)).json();
      const categoryNames = categoryData.map((category) => category.name);
      const filteredCategoryNames = [...categoryNames];
      filteredCategoryNames.sort((a, b) => (a === "all" ? -1 : b === "all" ? 1 : a.localeCompare(b)));
      setCategories(filteredCategoryNames);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return { educations, programming, user, skills, experience, projects, categories };
};
